export default "__VITE_ASSET__iysp7TLZ__"